<div class="flex-col height-100">

  <div class="welcome-image-full flex-col">
    <div class="client-banner" [class.client-banner]="_envSvc.hasClient()">
      <div class="logobox">
        <div [hidden]="_envSvc.hasClient()" class="logo"></div>
      </div>
    </div>
  </div>

  <div class="page-not-found">
    <div class="error-title">Error</div>
    <div class="error-code">404</div>
    <div class="error-description">Sorry this page has been moved or is no longer available</div>
  </div>
</div>